/* Offer page + offer cart (Prime Value Deals, Dawn) */
(function () {
  var TIMER_KEY = 'po_offer_end';
  var OFFER_KEY = 'po_last_offer';

  function pad(n) { return String(n).padStart(2, '0'); }
  function store(method, key, value) {
    try { return method === 'get' ? sessionStorage.getItem(key) : sessionStorage.setItem(key, value); }
    catch (e) { return null; }
  }

  /* One countdown shared by the offer page and the cart, restarts when it runs out */
  function getEnd(minutes) {
    var end = parseInt(store('get', TIMER_KEY), 10);
    var now = Date.now();
    if (!end || end <= now || end - now > minutes * 60000) {
      end = now + minutes * 60000;
      store('set', TIMER_KEY, String(end));
    }
    return end;
  }

  function initTimer(el) {
    if (el.dataset.poReady) return;
    el.dataset.poReady = '1';
    var minutes = parseInt(el.dataset.minutes, 10) || 10;
    var h = el.querySelector('[data-h]');
    var m = el.querySelector('[data-m]');
    var s = el.querySelector('[data-s]');
    var full = el.querySelector('[data-full]');
    function tick() {
      var left = Math.max(0, Math.round((getEnd(minutes) - Date.now()) / 1000));
      var hh = pad(Math.floor(left / 3600));
      var mm = pad(Math.floor((left % 3600) / 60));
      var ss = pad(left % 60);
      if (h) h.textContent = hh;
      if (m) m.textContent = mm;
      if (s) s.textContent = ss;
      if (full) full.textContent = hh + ':' + mm + ':' + ss;
    }
    tick();
    setInterval(tick, 1000);
  }

  function initViewers(el) {
    if (el.dataset.poReady) return;
    el.dataset.poReady = '1';
    var min = parseInt(el.dataset.min, 10) || 120;
    var max = parseInt(el.dataset.max, 10) || 150;
    if (max < min) max = min;
    var n = Math.round(min + Math.random() * (max - min));
    el.textContent = n;
    setInterval(function () {
      n = Math.min(max, Math.max(min, n + Math.round(Math.random() * 6 - 3)));
      el.textContent = n;
    }, 4000);
  }

  function initOffer(root) {
    if (root.dataset.poReady) return;
    root.dataset.poReady = '1';
    if (root.dataset.url) store('set', OFFER_KEY, root.dataset.url);

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-po-card]'));
    var sticky = root.querySelector('[data-po-sticky]');

    function select(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (!sticky) return;
      sticky.querySelector('[data-sticky-label]').textContent = card.dataset.label;
      sticky.querySelector('[data-sticky-price]').textContent = card.dataset.price;
      sticky.querySelector('[data-sticky-was]').textContent = card.dataset.was;
      sticky.querySelector('[data-sticky-id]').value = card.dataset.variant;
      var btn = sticky.querySelector('button');
      if (card.dataset.available === 'true') btn.removeAttribute('disabled');
      else btn.setAttribute('disabled', '');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { select(card); });
      card.addEventListener('keydown', function (e) {
        if (e.target !== card) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(card); }
      });
    });
  }

  function initCart(root) {
    if (root.dataset.poReady) return;
    root.dataset.poReady = '1';

    var last = store('get', OFFER_KEY);
    if (last) {
      root.querySelectorAll('[data-po-continue]').forEach(function (a) { a.setAttribute('href', last); });
    }

    root.querySelectorAll('[data-po-upgrade]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        fetch(root + 'cart/change.js', {
          method: 'POST', headers: headers,
          body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: 0 })
        })
          .then(function () {
            return fetch(root + 'cart/add.js', {
              method: 'POST', headers: headers,
              body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variant, 10), quantity: 1 }] })
            });
          })
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      });
    });
  }

  /* Add to cart via AJAX, then go to the cart page. Shows Shopify's error message if the add fails. */
  function showError(form, msg) {
    var el = form.querySelector('.po-atc-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'po-atc-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'margin:8px 0 0;font-size:12.5px;line-height:1.4;color:var(--po-sale,#E11D2E);text-align:center;';
      form.appendChild(el);
    }
    el.textContent = msg;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.po-card__form, [data-po-sticky] form')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { if (btn.getAttribute('aria-busy') === 'true') return; btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7'; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok) { window.location.href = root + 'cart'; return; }
        showError(form, res.j.description || res.j.message || 'Could not add this pack to the cart. Please try again.');
        if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }
        form.submit();
      });
  });

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-po-timer]').forEach(initTimer);
    scope.querySelectorAll('[data-po-viewers]').forEach(initViewers);
    scope.querySelectorAll('[data-po-offer]').forEach(initOffer);
    scope.querySelectorAll('[data-po-cart]').forEach(initCart);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
